import {
	type LocalPreference,
	preferenceStorageKey,
} from "src/common/utils/localPreference.js";
import type { CompletedExperience, ExperienceCatalogue } from "./types.js";

export const experiencePreferenceKey = (experienceId: string) =>
	`experience.${experienceId}`;

/** The localStorage entries that mark every catalogued experience as completed, for runs that must not meet a tour. */
export const completedExperienceEntries = (
	catalogue: ExperienceCatalogue,
	at: string,
): { name: string; value: string }[] =>
	Object.entries(catalogue).map(([experienceId, experience]) => ({
		name: preferenceStorageKey(experiencePreferenceKey(experienceId)),
		value: JSON.stringify({
			updatedAt: at,
			value: { completedAt: at, version: experience.version },
		} satisfies LocalPreference<CompletedExperience>),
	}));
